var map = {
	"./buy-crypto-card.svg": 1128,
	"./buy.svg": 1129,
	"./delete.svg": 1130,
	"./desktop.svg": 1131,
	"./gear.svg": 1132,
	"./order-failed.svg": 1133,
	"./order-success.svg": 1134,
	"./pass-kyc.svg": 1135,
	"./question.svg": 1136,
	"./successfull-order.svg": 1137
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1127;